module.exports = __webpack_public_path__ + "static/media/audio.4e22bb25.jpg";